import React from 'react';
import { AiFillGithub, AiOutlineTwitter } from 'react-icons/ai';
import { FaLinkedinIn } from 'react-icons/fa';
import useFadeIn from './useFadeIn';
import './Contact.css';

const SOCIALS = [
  { Icon: AiFillGithub,     label: 'GitHub',   href: 'https://github.com/JaydeepKaushik26' },
  { Icon: FaLinkedinIn,     label: 'LinkedIn',  href: 'https://www.linkedin.com/in/jaydeepkaushik/' },
  { Icon: AiOutlineTwitter, label: 'Twitter',   href: 'https://x.com/JaydeepKaushi15' },
];

function Contact() {
  const ref = useFadeIn();

  return (
    <section id="contact" className="section contact-section fade-in" ref={ref}>
      <p className="section-eyebrow">04 — Contact</p>
      <h2 className="section-heading">Let's Connect</h2>
      <div className="section-divider contact-divider" />

      <p className="contact-desc">
        I'm always open to new opportunities, collaborations, or just a good conversation about
        technology. Reach out anytime, I'd love to hear from you.
      </p>

      <div className="social-row">
        {SOCIALS.map(({ Icon, label, href }) => (
          <a className="social-btn" key={label} href={href} target="_blank" rel="noreferrer">
            <Icon size={18} />
            <span>{label}</span>
          </a>
        ))}
      </div>
    </section>
  );
}

export default Contact;
